<template>
    <div v-if="filteredAutomations.length">
        <v-row no-gutters>
            <v-col class="col-sm-6 col-6 pa-0 mb-3 d-flex align-center">
                <div class="caption n3--text">{{ $t("Automation") }}</div>
            </v-col>
        </v-row>
        <v-row no-gutters :class="isFullPage ? 'ml-3' : ''">
            <v-col
                v-for="(item, index) in filteredAutomations"
                :key="index"
                cols="12"
                class="mb-4"
            >
                <AutomationRow
                    :item="item"
                    :can-edit="canEdit"
                    :placeholder-data="placeholderData"
                    :emailing-enabled="emailingEnabled"
                    :can-send-now="canSendNow"
                    :is-full-page="isFullPage"
                    :client-id="clientId"
                    :company-id="accountId"
                    @send-now="sendNow(index)"
                    @delete="deleteRow(index)"
                    @edit="editRow(index)"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { $t } from "@/i18n";
import AutomationRow from "./Rows/AutomationRow";
import { deepClone } from "@/helpers/helpers";
import DialogModule from "../../../store/modules/dialog";
import { TASK_AUTOMATION_STATUS } from "../../../helpers/constants";
import { computed } from "@vue/composition-api";

export default {
    name: "TaskAutomationList",
    components: {
        AutomationRow
    },
    props: {
        automations: {
            type: Array,
            default: null
        },
        accountId: {
            type: Number,
            default: null
        },
        canEdit: {
            type: Boolean,
            required: true
        },
        placeholderData: {
            type: Object,
            default: null
        },
        emailingEnabled: {
            type: Boolean,
            required: true
        },
        canSendNow: {
            type: Boolean,
            required: true
        },
        isFullPage: {
            type: Boolean,
            required: true
        },
        clientId: {
            type: Number,
            default: null
        }
    },
    setup(props, ctx) {
        const dialogModule = DialogModule();

        const deleteRowConfirmed = function (index) {
            let automationsCopy = deepClone(props.automations)
            automationsCopy.splice(index, 1)

            ctx.emit('updateAutomations', automationsCopy)
        };

        const deleteRow = (index) => {
            dialogModule.setConfirmOptions({
                title: $t("Are you sure to delete this email?"),
                confirm_text: $t("Delete"),
                cancel_text: $t("Cancel"),
                action: () => deleteRowConfirmed(index)
            });
            dialogModule.openConfirmDialog();
        }

        const editRow = (index) => {
            ctx.emit('editAutomation', index)
        }

        const sendNowConfirmed = (index) => {
            let automationsCopy = deepClone(props.automations)
            automationsCopy[index].trigger = ''
            automationsCopy[index].days = 0

            ctx.emit('updateAutomations', automationsCopy)
        }

        const sendNow = (index) => {
            dialogModule.setConfirmOptions({
                title: $t("Are you sure you wish to send this email immediately?"),
                confirm_text: $t("Send"),
                cancel_text: $t("Cancel"),
                action: () => sendNowConfirmed(index)
            });
            dialogModule.openConfirmDialog();
        }

        const filteredAutomations = computed(() => props.automations.filter(x => x.status === TASK_AUTOMATION_STATUS.NEW))

        return {
            deleteRow,
            editRow,
            sendNow,
            filteredAutomations
        };
    }
};
</script>
